import {
  UPDATE_WHATSAPP_QUEUES,
  RESET_WHATSAPP,
  SET_CONVERSATION_LIST,
  SET_CONVERSATION_BY_PROTOCOL,
  SET_SEARCH_CONVERSATION_DRAWER,
  SET_MEDIA_GALLERY_DIALOG,
  SET_WHATSAPP_ALL_MIDIA,
  SET_FORWARD_MESSAGE_DIALOG,
  SET_FORWARD_MESSAGE_INITIALIZED,
  SET_FORWARD_MESSAGE_SELECTION,
  SET_ACTIVE_SESSION_STATUS,
  SET_FORWARD_MESSAGE_PROTOCOL,
  CLEAR_FORWARD_MODULE,
} from '../../mutation-types';

const mutations = {
  [UPDATE_WHATSAPP_QUEUES](state, queues) {
    state.queues = queues;
  },

  [RESET_WHATSAPP](state) {
    state.queues = [];
  },

  [SET_WHATSAPP_ALL_MIDIA](state, value) {
    state.attachmentWhatsappAllMidia = [];
    state.attachmentWhatsappAllMidia = value;
  },

  [SET_SEARCH_CONVERSATION_DRAWER](state, value) {
    state.searchConversationDrawer = value;
  },

  [SET_CONVERSATION_LIST](state, value) {
    if (value != 'reset') {
      state.searchConversationTotalPages = value.totalPages;
      value.data.forEach((conversation) => {
        state.conversationList.push(conversation);
      });
      return;
    }
    state.searchConversationTotalPages = null;
    state.conversationList = [];
  },

  [SET_CONVERSATION_BY_PROTOCOL](state, value) {
    state.conversationByProtocol = value;
  },
  [SET_MEDIA_GALLERY_DIALOG](state, { imageRef, status }) {
    state.mediaGalleryDialog = { imageRef, status };
  },
  [SET_FORWARD_MESSAGE_DIALOG](state, status) {
    state.forwardMessage.dialog = status;
  },
  [SET_FORWARD_MESSAGE_INITIALIZED](state, status) {
    state.forwardMessage.initialized = status;
  },
  [SET_FORWARD_MESSAGE_SELECTION](state, { messageId, checked }) {
    const list = state.forwardMessage.messageList;
    const index = list.indexOf(messageId);
    if (checked) {
      list.push(messageId);
    } else {
      list.splice(index, 1);
    }
  },
  [CLEAR_FORWARD_MODULE](state) {
    state.forwardMessage.initialized = false;
    state.forwardMessage.dialog = false;
    state.forwardMessage.messageList = [];
    state.forwardMessage.activeSessionStatus = [];
    state.forwardMessage.protocol = null;
  },
  [SET_ACTIVE_SESSION_STATUS](state, value) {
    state.forwardMessage.activeSessionStatus = value;
  },
  [SET_FORWARD_MESSAGE_PROTOCOL](state, protocol) {
    state.forwardMessage.protocol = protocol;
  },
};

export default mutations;
